import React, { useState, useEffect } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import { toast } from 'react-toastify';
import axios from 'axios';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../../config/firebase';
import IconButton from 'components/common/IconButton';
import PageHeader from 'components/common/PageHeader';
import FalconComponentCard from 'components/common/FalconComponentCard';

const EditWebsiteContentForm = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    title: '',
    content: '',
    section: '',
    enabled: true,
  });

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        const uid = user.uid;
        setFormData({
          ...formData,
          user_id: uid,
        });
      } else {
        navigate('/login');
      }
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const id = window.location.pathname.split('/').pop();

      if (id) {
        try {
          const apiUrl = `${process.env.REACT_APP_API_URL}`;

          const response = await axios.get(`${apiUrl}/website-content/id/${id}`);

          if (response.data) {
            const eventData = response.data[0];
            console.log('eventData', eventData);

            setFormData({
              title: eventData.title,
              section: eventData.section,
              content: eventData.content,
              enabled: eventData.enabled === 'false' ? false : true,
            });
          }
        } catch (err) {
          console.log('Error', err);
        }
      } else {
        navigate('/website-contents/list');
      }
    };

    fetchData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const id = window.location.pathname.split('/').pop();

    try {
      let formData2 = new FormData();
      formData2.append('title', formData.title);
      formData2.append('section', formData.section);
      formData2.append('content', formData.content);
      formData2.append('enabled', formData.enabled);

      const response = await axios.put(`${process.env.REACT_APP_API_URL}/website-content/id/${id}`, formData2);

      if (response) {
        toast.success(`Website content uploaded successfully`, {
          theme: 'colored',
        });
      }
    } catch (err) {
      console.log('Error', err.message);
    }
  };

  const handleFieldChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  return (
    <>
      <PageHeader
        title="Update website content"
        description="This new content will be displayed on the relevant section on a website page."
        className="mb-3"
      ></PageHeader>

      <FalconComponentCard>
        <FalconComponentCard.Header title="Details" light={false} noPreview={true}></FalconComponentCard.Header>
        <Form onSubmit={handleSubmit}>
          <FalconComponentCard.Body>
            <Form.Label>Title</Form.Label>
            <Form.Control
              size="lg"
              type="text"
              placeholder=""
              name="title"
              onChange={handleFieldChange}
              defaultValue={formData.title}
            />
            <br />
            <Form.Label>Section</Form.Label>
            <Form.Control
              size="lg"
              type="text"
              placeholder=""
              name="section"
              onChange={handleFieldChange}
              defaultValue={formData.section}
            />
            <br />

            <Form.Label>Content</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              name="content"
              onChange={handleFieldChange}
              defaultValue={formData.content}
            />
            <br />

            <Row>
              <Col lg="4">
                <Form.Group>
                  <Form.Check
                    name="enabled"
                    type="checkbox"
                    id="enabledCheckbox"
                    label="Enabled"
                    onChange={(e) => setFormData({ ...formData, enabled: e.target.checked })}
                    checked={formData.enabled}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col lg="6" className="mt-4 mb-3 ml-3">
                <Form.Group>
                  <IconButton
                    className="mb-1"
                    variant="falcon-default"
                    size="lg"
                    icon="plus"
                    transform="shrink-3"
                    type="submit"
                  >
                    Submit
                  </IconButton>
                </Form.Group>
              </Col>
            </Row>
          </FalconComponentCard.Body>
        </Form>
      </FalconComponentCard>
    </>
  );
};

export default EditWebsiteContentForm;
